import {Icon, Tooltip, view} from '@sail/ui';
import {warning} from '@sail/icons/react/Icon';

import {ChatRowContainer} from '@stripe-internal/conversations-ui';

type Props = {
  position?: 'start' | 'end';
  error?: React.ReactNode;
  children: React.ReactNode;
};

const ErrorMessage = ({children}: {children: React.ReactNode}): JSX.Element => {
  return (
    <Tooltip
      placement="left"
      delay={0}
      trigger={
        <Icon
          icon={warning}
          aria-label="warning"
          data-testid="error-tooltip-icon"
          css={{
            fill: 'red',
          }}
        />
      }
    >
      {children}
    </Tooltip>
  );
};

export const ChatRow = ({
  children,
  position = 'start',
  error,
}: Props): JSX.Element => {
  const innerNodes = [
    error ? <ErrorMessage key="error">{error}</ErrorMessage> : null,
    children,
  ];

  return (
    <view.div
      data-testid="chat-row"
      css={{
        marginLeft: position === 'start' ? 0 : 'xxlarge',
        marginRight: position === 'start' ? 'xxlarge' : 0,
      }}
    >
      <ChatRowContainer position={position}>
        {position === 'start' ? innerNodes : innerNodes.reverse()}
      </ChatRowContainer>
    </view.div>
  );
};
